/* globals Knitiv */

class FormSelectController {
	/** @type {Knitiv.RootScope} */
	$rootScope;

	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$location,
		$rootScope,
		$timeout,
		$translate,
		FormService,
		Notification,
		User,
	) {
		this.class = undefined;
		this.classes = undefined;

		/** @type {any} */
		this.tmp = {};

		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.FormService = FormService;
		this.Notification = Notification;
		this.User = User;

		this.canCreate = this.$rootScope.context?.role.mode === 'ADMIN_SUPER'
			|| this.$rootScope.context?.role.mode === 'ADMIN_SYS'
			|| this.$rootScope.context?.role.sql_in.includes('K_NODE;KR_OWNER_ADM');
	}

	/**
	 * @param {File} file
	 * @param {string | any[]} invalidFiles
	 */
	async importFile(file, invalidFiles) {
		if (file) {
			const item = await this.FormService.objectImportJSON(file);
			this.$location.url(`/form/${item.kid}/create?from=form`);
		}
		if (invalidFiles.length > 0) {
			for (const invalidFile of invalidFiles) {
				if (invalidFile.$error === 'pattern') {
					this.Notification.error({
						title:   this.$translate.instant('error.title'),
						message: this.$translate.instant('error.no-json-file'),
					});
				}
			}
		}
	}

	async loadClasses() {
		const classes = (await this.FormService.loadClasses()) || [];
		this.$timeout(() => {
			this.classes = classes;
		});
	}

	/**
	 * @param {any} item
	 */
	openClass(item) {
		this.$location.url(`/form/${item.kid}/create?from=form&newKid=${this.tmp.newKid}`);
	}

	$onInit() {
		this.tmp.newKid = `K_NODE;${this.User.getRef()}`;
		(async () => this.loadClasses())();
		this.$location.url('/form');
	}
}

export default FormSelectController;
